<div class="description" *ngIf="errorCode">{{ errorCode | errorCode }}</div>
